import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      editionMode: 'dossier/getEditionMode',
      auth: 'auth/getAuth',
      errors: 'auth/getErrors'
    }),
    errorsIsEmpty() {
      return Object.keys(this.errors).length < 1
    },
    displayMode() {
      return this.auth?.settings?.default_view_preference ?? 'view'
    },
  },
  methods: {
    ...mapActions({
      fetchDossierById: 'dossier/fetchDossierByID'
    }),
    ...mapMutations({
      setDossierEditionModeMutation: 'dossier/setEditionMode',
      processSetLeaveRouteByButtonMutation: 'dossier/setLeaveRouteByButton'
    }),
    handleUnsavedChangesNotification(
      route_to,
      route_from,
      route_next,
      update_function
    ) {
      this.$h.unsavedChangesNotification(() => {
        // if (
        //   route_from.meta.display_type === 'edit' &&
        //   route_to.meta.display_type === 'view'
        // ) {
        //   // console.log('handleUnsavedChangesNotification fetch')
        //   this.fetchDossierById(this.$route.params.id)
        // }
        route_next()
      })
    }
  }
}
